import {MenuOption, PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const"
import Task from "../../../../model2/task/task"
import TaskMore_ActionsPopoverMenu from "./actions-popover-menu"
import {taskMore_getAvailableActions} from "./run-action"

export type Props = {
    task            : Task

    hidePopover?    : callback
}

export function taskMore_initActions(props: Props, menuOptions: MenuOption[]) {

    const availableActions  = taskMore_getAvailableActions(props.task)
    const canAddAction      = gd.ac.check.createAutomation() && gd.ac.check.automation.enabled()

    if (
        _.isEmpty(availableActions)
        && !canAddAction
    ) {
        return
    }

    menuOptions.push({
        type            : PopoverMenuItemType.CUSTOM_POPOVER,
        icon            : 'ii5-lightning',
        label           : 'Actions',
        menuComponent   : TaskMore_ActionsPopoverMenu,
        menuParams      : {
            task        : props.task,
            hidePopover : props.hidePopover,
        },
    })
}
